
import React from "react";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { AgeGenderFields } from "./demographics/AgeGenderFields";
import { EducationEmploymentFields } from "./demographics/EducationEmploymentFields";
import { PoliticalIncomeFields } from "./demographics/PoliticalIncomeFields";
import { ResidenceField } from "./demographics/ResidenceField";
import { useDemographicsForm } from "./demographics/useDemographicsForm";

export default function DemographicsForm() {
  const { form, onSubmit } = useDemographicsForm();

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <AgeGenderFields control={form.control} />
          <EducationEmploymentFields control={form.control} />
          <PoliticalIncomeFields control={form.control} />
          <ResidenceField control={form.control} />
        </div>
        
        <Button type="submit" variant="purple" className="mt-4">
          Save Demographics
        </Button>
      </form>
    </Form>
  );
}
